export default "__VITE_ASSET__BAuQbrNx__"